<template>
  <!-- 购买会员页面 -->
  <div class="vipbuy">
    <Top></Top>
    <!-- <div class="order-tip">
      <div class="main-row acea-row row-middle" style="height: 100%;">
        <img src="../imgs/success.svg" style="width: 100px;height: 100px;">
        <div style="margin-left: 20px;">
          <div style="font-size: 21px;">订单提交成功，请尽快完成付款！</div>
          <div style="font-size: 14px;margin-top: 15px;">请在48小时内完成支付，否则订单将会自动取消</div>
        </div>
        <div style="margin-left: 180px;">
          <div style="font-size: 21px;">官方客服咨询微信:</div>
         
        </div>
        <img src="../imgs/weier.jpg" style="width: 100px;height: 100px; margin-left: 30px;">

      </div>

    </div> -->
    <div class="main-row">
      <div style="margin-top: 50px;color: #5c5c5c;">订单详情，套餐编号： {{ showInfo.menuNumber }}</div>
      <div class="order-table" style="">
        <div class="table-header acea-row">
          <div style="flex: 1;">套餐名称</div>
          <div style="flex: 1;">图片/视频总量</div>
          <div style="flex: 1;">均价元</div>
          <div style="flex: 1;">总价元</div>
          <div style="flex: 2;">有效期</div>
        </div>
        <!-- 套餐1 -->
        <div class="table-row acea-row">
          <div class="menuName" style="flex: 1;">{{ showInfo.menuName }}</div>
          <div class="availableNumber" style="flex: 1;">{{ showInfo.availableNumber }}</div>
          <div class="unitPrice" style="flex: 1;">{{ showInfo.unitPrice }}</div>
          <div class="menuPrice" style="flex: 1;font-weight: bold;">{{ showInfo.menuPrice }}</div>
          <div class="effectiveDay" style="flex: 2;"> {{ dataStart }} 至 {{ dataEnd1 }}</div>
        </div>
        <!-- 套餐2 -->
        <!-- <div v-else-if="payActive == 2" class="table-row acea-row">
          <div class="menuName" style="flex: 1;">{{ showInfo[1].menuName }}</div>
          <div class="availableNumber" style="flex: 1;">{{ showInfo[1].availableNumber }}</div>
          <div class="unitPrice" style="flex: 1;">{{ showInfo[1].unitPrice }}</div>
          <div class="menuPrice" style="flex: 1;font-weight: bold;">{{ showInfo[1].menuPrice }}</div>
          <div class="effectiveDay" style="flex: 2;"> {{ dataStart }} 至 {{ dataEnd2 }}</div>
        </div> -->
        <!-- 套餐3 -->
        <!-- <div v-else class="table-row acea-row">
          <div class="menuName" style="flex: 1;">{{ showInfo[2].menuName }}</div>
          <div class="availableNumber" style="flex: 1;">{{ showInfo[2].availableNumber }}</div>
          <div class="unitPrice" style="flex: 1;">{{ showInfo[2].unitPrice }}</div>
          <div class="menuPrice" style="flex: 1;font-weight: bold;">{{ showInfo[2].menuPrice }}</div>
          <div class="effectiveDay" style="flex: 2;"> {{ dataStart }} 至 {{ dataEnd3 }}</div>
        </div> -->
      </div>
      <div style="font-size: 14px;margin: 15px 10px;color: #5C5C5C;">
        套餐从开通当日起算，有效期为{{ showInfo.effectiveDay }}个自然日，图片/视频按授权约定范围，在有效期内可任意使用。</div>
      <!-- <div v-if="payActive == 2" style="font-size: 14px;margin: 15px 10px;color: #5C5C5C;">
        套餐从开通当日起算，有效期为{{ showInfo[1].effectiveDay }}个自然日，图片/视频按授权约定范围，在有效期内可任意使用。</div>
      <div v-if="payActive == 3" style="font-size: 14px;margin: 15px 10px;color: #5C5C5C;">
        套餐从开通当日起算，有效期为{{ showInfo[2].effectiveDay }}个自然日，图片/视频按授权约定范围，在有效期内可任意使用。</div>
      <div style="font-size: 28px;margin-top: 70px;margin-bottom: 50px;">支付方式</div> -->
      <div class="acea-row row-between-wrapper" style="margin-top:100px;margin-bottom: 100px;">
        <div class="pay-item" @click="payType = 2" :class="payType === 2 ? 'active' : ''">
          <div class="radio"></div>
          <img src="../imgs/wxpay.svg" class="pay-icon">
          <div>微信支付</div>
        </div>
        <div class="pay-item" @click="payType = 3" :class="payType === 3 ? 'active' : ''">
          <div class="radio"></div>
          <img src="../imgs/zhuanzhang.svg" class="pay-icon">
          <div>
            <div>线下汇款/转账</div>
            <div class="huikuan" style="">
              <div class="huikuan-time" style="">请在48小时内进行汇款；</div>
              <div>将在1-3个工作日到账后开通服务。</div>
            </div>
          </div>
        </div>
      </div>
      <div style="text-align: right;font-size: 28px;margin-top: 50px;color: #5c5c5c;">应付金额：<span
          style="color: #E73D4A;font-weight: bold;" class="pay-price">￥
          {{ showInfo.menuPrice }}</span></div>
      <div class="acea-row row-middle row-right" style="margin-top: 30px;margin-bottom: 100px;">
        <el-checkbox class="promiseCheckBox" :value="checked" @change='checked = !checked'></el-checkbox>

        <div style="margin-left: 10px;margin-right: 30px;color: #5c5c5c;">我已阅读并同意《云上世界会员协议》</div>

        <el-button id="pay-btn" type="primary" @click="pay">去付款</el-button>
      </div>
    </div>
    <!-- <div
      v-if="showTip"
      class="qa-tip acea-row row-center-wrapper"
    >
      <div class="qa-content">
        <div style="font-size: 30px;font-weight: bold;">您是否完成支付？</div>
        <div style="margin-top: 40px;">若支付时遇到问题请联系客服微信：yilvkeji</div>
        <div
          class="acea-row row-center-wrapper"
          style="margin-top: 40px;"
        >
          <div
            class="qa-btn qa-btn-success"
            style="background-color: #E73D4A;color: #FFFFFF;"
            @click="paySUccess"
          >已完成支付</div>
          <div
            class="qa-btn qa-btn-fail"
            style="background-color: #e5e5e5;margin-left: 30px;"
            @click="payFile"
          >支付失败</div>
        </div>
        <div
          class="close-btn acea-row row-center-wrapper"
          @click="showTip=false"
        >
          <img
            class="qa-close"
            src="../imgs/cha.svg"
            style="width: 20px;height: 20px;"
          >
        </div>
      </div>
    </div> -->

    <!-- 成功对话框 -->
    <!-- <div
      v-if="paySuccessDialog"
      class="qa-tip acea-row row-center-wrapper"
    >
      <div class="qa-content">
        <div
          class="acea-row row-center-wrapper"
          style="color: #DC3B3B;font-weight: bold;"
        >
          <div style="margin-right: 40px;">
            <img
              src="../imgs/gou.svg"
              style="width: 50px;"
            >
          </div>
          <span>付款成功</span>
        </div>
        <div style="margin-top: 40px;">恭喜，您已成为云上世界的尊贵会员</div>
        <div
          class="acea-row row-center-wrapper"
          style="margin-top: 40px;"
        >

          <a
            href="./mine-order.html"
            class="confirm-btn"
            style="background-color: #E73D4A;color: #FFFFFF;"
          >进入会员中心</a>
        </div>
        <div
          class="close-btn acea-row row-center-wrapper"
          @click="paySuccessDialog=false"
        >
          <img
            class="qa-close"
            src="../imgs/cha.svg"
            style="width: 20px;height: 20px;"
          >
        </div>
      </div>
    </div> -->
    <!-- 失败对话框 -->
    <!-- <div
      v-if="payFailDialog"
      class="qa-tip acea-row row-center-wrapper"
    >
      <div class="qa-content">
        <div style="margin-top: 80px;">未检测到您的支付订单，如支付遇到问题，请联系 微信客服</div>
        <div
          class="acea-row row-center-wrapper"
          style="margin-top: 40px;"
        >
          <div
            @click="payFailDialog=false"
            class="confirm-btn"
            style="background-color: #E73D4A;color: #FFFFFF;"
          >关闭</div>
        </div>
        <div
          class="close-btn acea-row row-center-wrapper"
          @click="payFailDialog=false"
        >
          <img
            class="qa-close"
            src="../imgs/cha.svg"
            style="width: 20px;height: 20px;"
          >
        </div>
      </div>
    </div> -->



    <el-dialog center style="margin-top:100px" title="提示！" :visible.sync="payVisible" width="40%">

      <div class="payDiologText">
        <p style="color: #000;">检测到您有未支付订单，请先支付或先关闭订单！</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleNoOrder">处理未支付订单</el-button>
      </span>
    </el-dialog>
    <service />
    <Foot></Foot>
  </div>
</template>
<script>
import service from '@/components/service.vue'
import Top from "../components/top.vue";
import Foot from "../components/foot.vue";
import { getlocalStorage } from "../utils/auth"
import dayjs from 'dayjs'
export default {
  name: "vipbuy",
  components: { Top, Foot },
  data() {
    return {
      // currentVip: {
      //   effectiveDay: 111,
      //   menuPrice: 123,
      // },
      checked: false,
      payType: 2,
      btnDisabled: false,
      paySuccessDialog: false,
      showTip: false,
      payFailDialog: false,
      menberList: [],//套餐列表
      showInfo: [],//套餐信息
      payActive: this.$route.query.payActive,
      dataStart: '',//当前时间
      dataEnd1: '',
      dataEnd2: '',
      dataEnd3: '',
      dataAli: '', //支付宝支付
      dataWx: '', //微信支付
      dataBank: '', //银行卡支付订单号
      payVisible: false, //未支付订单对话框
    };
  },
  created() {
    // 当前时间改成用-链接的格式
    this.dataStart = dayjs(new Date()).format('YYYY-MM-DD')
    this.dataEnd1 = this.getNewDay(this.dataStart, 30)
    this.dataEnd2 = this.getNewDay(this.dataStart, 90)
    this.dataEnd3 = this.getNewDay(this.dataStart, 365)
    // console.log(this.payActive);
    this.vipValue()
    // const token = window.localStorage.getItem('token')
    // console.log(token);
  },
  methods: {
    async vipValue() {
      // 先请求全部的列表在根据去找当前的项
      const res = await this.$axios.get('/member/findAllMember')
      // console.log(res);
      this.menberList = res.data
      // console.log(this.menberList);
      this.menberList.forEach(item => {
        if (item.menuNumber == this.$route.query.menuNumber) {
          this.showInfo = item
        }
      })
      // console.log(this.showInfo);

    },
    async pay() {
      if (!this.checked) {
        return this.$message.error('请勾选会员协议')
      }
      // this.payFailDialog = true
      this.btnDisabled = true
      this.showTip = true
      //微信支付
      if (this.payType == 2) {
        const menuNumber = this.showInfo.menuNumber
        let formData = new FormData()
        formData.append('menuNumber', menuNumber)
        // console.log(formData);
        const res = await this.$axios.post('/pay/WeixinPay', formData)

        if (res.code == 6020) {
          this.payVisible = true
        } else {
          const dd = this.$router.resolve({
            path: "/payWx",
            query: {
              menuNumber: this.showInfo.menuNumber,
              data: this.dataWx.out_trade_no
            }

          })
          // console.log(dd);
          window.open(dd.href, '_blank');
        }


      }
      //银行支付
      if (this.payType == 3) {
        const dd = this.$router.resolve({
          path: "/payBank",
          query: {
            menuNumber: this.showInfo.menuNumber,
            price: this.showInfo.menuPrice
          }

        })
        // console.log(dd);
        window.open(dd.href, '_blank');
      }

    },
    // 点击对话框支付失败按钮
    payFile() {
      // 关闭提示框
      this.showTip = false
      // 重新请求，刷新页面
      this.vipValue()
    },
    // 点击对话框支付成功按钮
    async paySUccess() {
      this.dialogVisible = true;
      const res = await this.$axios.post('/pay/WxQueryOrder', { out_trade_no: this.dataWx.out_trade_no, menuNumber: this.$route.query.menuNumber })
      // console.log(res.data);
      if (res.data == '会员添加成功!') {
        this.paySuccessDialog = true;
      } else {
        this.payFailDialog = true;
      }
    },
    // 点击处理未支付订单
    handleNoOrder() {
      this.$router.push('/userIndex')
    },


    // 处理时间函数（开始日期~结束日期）
    getNewDay(dateTemp, days) {
      dateTemp = dateTemp.split("-");
      //转换为MM-DD-YYYY格式
      var nDate = new Date(dateTemp[1] + "-" + dateTemp[2] + "-" + dateTemp[0]);
      var millSeconds = Math.abs(nDate) + days * 24 * 60 * 60 * 1000;
      var rDate = new Date(millSeconds);
      var year = rDate.getFullYear();
      var month = rDate.getMonth() + 1;
      if (month < 10) month = "0" + month;
      var date = rDate.getDate();
      if (date < 10) date = "0" + date;
      return year + "-" + month + "-" + date;
    },
  },


};
</script>
<style lang="scss" scoped>
body,
html {
  background-color: #ffffff;
}

.vipbuy {
  // margin-top: 100px;
}

.order-tip {
  min-width: 1200px;
  width: 100%;
  height: 200px;
  background-color: #f9f5f2;
}

.order-table {
  width: 100%;
  margin-top: 15px;
  border: 1px solid #ccc;
  border-bottom: none;
}

.table-header,
.table-row {
  width: 100%;
  height: 68px;
  border-bottom: 1px solid #ccc;
  color: #5c5c5c;
}

.table-header>div {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #f5f5f5;
}

.table-row>div {
  display: flex;
  justify-content: center;
  align-items: center;
}

.pay-item {
  width: 391px;
  height: 164px;
  border: 2px solid #eeeeee;
  cursor: pointer;
  display: flex;
  align-items: center;
  padding-left: 24px;
  box-sizing: border-box;
  font-size: 28px;
  position: relative;
  color: #5c5c5c;
}

.pay-item.active {
  border: 2px solid #e73d4a;
}

.radio {
  width: 20px;
  height: 20px;
  border: 1px solid #b3b3b3;
  border-radius: 50%;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  transform: scale(0.8);
  /* 16px的圆看起来不居中 */
}

.pay-item.active .radio::after {
  content: "";
  width: 14px;
  height: 14px;
  background-color: #dc3b3b;
  border-radius: 50%;
  /* position: absolute;
				left: 50%;
				top: 50%;
				margin-top: -6px;
				margin-left: -6px; */
}

.pay-icon {
  width: 65px;
  height: 65px;
  margin-left: 20px;
  margin-right: 30px;
}

#pay-btn {
  width: 239px;
  height: 48px;
  background-color: #e73d4a;
  text-align: center;
  // line-height: 48px;
  color: #ffffff;
  border-radius: 5px;
  font-size: 20px;
  cursor: pointer;
}

.qa-tip {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: rgba(1, 1, 1, 0.2);
  display: flex;
  z-index: 9999;
}

.qa-content {
  width: 700px;
  height: 310px;
  background-color: #ffffff;
  padding-top: 40px;
  text-align: center;
  position: relative;
}

.qa-btn {
  width: 166px;
  height: 55px;
  text-align: center;
  line-height: 55px;
  border-radius: 4px;
  cursor: pointer;
}

.close-btn {
  position: absolute;
  width: 70px;
  height: 70px;
  background-color: #ffffff;
  border-radius: 50%;
  right: -100px;
  top: 0;
  cursor: pointer;
}

.confirm-btn {
  width: 250px;
  height: 50px;
  text-align: center;
  line-height: 50px;
  border-radius: 4px;
  cursor: pointer;
}

.main-row {
  width: 1200px;
  margin: 0 auto;
}

.acea-row {
  display: flex;
  flex-wrap: wrap;
}

.acea-row.row-middle {
  align-items: center;
}

.acea-row.row-center {
  justify-content: center;
}

.acea-row.row-center-wrapper {
  align-items: center;
  justify-content: center;
}

.acea-row.row-between-wrapper {
  align-items: center;
  /* justify-content: flex-start; */
  justify-content: center;
}

.acea-row.row-column {
  flex-direction: column;
}

.acea-row.row-right {
  justify-content: flex-end;
}

.flex1 {
  flex: 1;
}

div,
header,
footer {
  box-sizing: border-box;
}

.footer .link-icon {
  width: 24px;
  height: 24px;
  object-fit: contain;
}

.footer-top {
  width: 100%;
  height: 130px;
  border-bottom: 1px solid #707070;
}

.footer .link-item {
  margin-right: 40px;
  cursor: pointer;
}

/deep/ .el-button--primary.is-disabled,
.el-button--primary.is-disabled:active,
.el-button--primary.is-disabled:focus,
.el-button--primary.is-disabled:hover {
  background-color: #ccc !important;
}


.payDiologText {
  font-size: 14px;
  font-weight: bold;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.huikuan {
  font-size: 14px;
  margin-top: 10px;

  .huikuan-time {
    margin-bottom: 10px;
  }
}




.mianBox {
  margin-bottom: 200px;
}

.pay-method-text {
  font-size: 28px;
  margin-top: 70px;
  margin-bottom: 50px;
}

.pay-money {
  text-align: right;
  font-size: 28px;
  margin-top: 50px;
  color: #5c5c5c;
}

.allow {
  margin-left: 10px;
  margin-right: 30px;
  color: #5c5c5c;
}
</style>



// WEBPACK FOOTER //
// src/vip/vipbuy.vue